<div
  style="
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    align-content: flex-start;
    gap: 10px;
    background: #303030;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  "
>
  <div style="order: 1; flex: 90">
    <div
      style="
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: columns;
        flex-wrap: nowrap;
        flex: 1;
      "
    >
      <div style="order: 1; justify-content: center">
        <a href="/dashboard">
          <img src="/CDI_LOGO.svg" height="45px" alt="Cascade Designs Inc."
        /></a>
      </div>
    </div>
  </div>

  <div style="order: 2; flex: 10">
    <div
      style="
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        padding: 15px;
        gap: 5px;
      "
    >
      <div style="order: 1"></div>
      <div style="order: 3"></div>
    </div>
  </div>
</div>
